export default __webpack_public_path__ + "images/catalog-analyzer-active.svg";